import axios from "axios";
import { message } from "antd";
import toast from "react-hot-toast";

const url = process.env.REACT_APP_API_BASE_URL;

 
export const handleLogout = async () => {
  await message.info("Session has expired. Log in to continue");
  await localStorage.clear();
  window.location = await "./login";
  await window.location.reload();
};


const axiosInstance = axios.create({
    baseURL: url,
    headers: {
        'Content-Type': 'application/json',
    },
});



axiosInstance.interceptors.response.use(response => {
    const data = response?.data;
    if (data?.success === false && data?.messages?.message?.includes("PERMISSION DENIED")) {
        toast.error(data?.messages?.message);
    }

    return response;
}, (error) => { 
		const statusCode = error.response ? error.response.status : null;
 

		if (statusCode == 403) {
			handleLogout();
		}

		if (statusCode == 401) {
			handleLogout();
		} 
		

		return Promise.reject(error);
	});

export default axiosInstance;